<template>
    <DCard padding>
        <DCol>
            <DRow class="mb-3">
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <DInput
                        id="customer-id"
                        v-model="dataFilters.customerId"
                        :label="__('tools.providerbox.filters.customer_id')"
                        class="mb-0"
                        @keydown.enter.exact.prevent="changePage"
                    />
                </DCol>
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <DInput
                        id="contract-id"
                        v-model="dataFilters.contractId"
                        :label="__('tools.providerbox.filters.contract_id')"
                        class="mb-0"
                        @keydown.enter.exact.prevent="changePage"
                    />
                </DCol>
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <DInput
                        id="invoice-id"
                        v-model="dataFilters.invoiceId"
                        :label="__('tools.providerbox.filters.invoice_id')"
                        class="mb-0"
                        @keydown.enter.exact.prevent="changePage"
                    />
                </DCol>
            </DRow>
            <DRow class="mb-3">
                <DCol
                    sm="3"
                    class="d-flex gap-2"
                >
                    <DButton
                        id="filter-apply"
                        :label="__('tools.providerbox.filters.filter')"
                        @click="changePage"
                    />
                    <DButton
                        id="filter-reset"
                        icon="filter-off"
                        :label="__('messages.actions.reset_filter')"
                        @click="resetFilters"
                    />
                </DCol>
            </DRow>
        </DCol>
        <DTable
            :items="invoices.items"
            :fields="fields"
            hover
        >
            <template #customerId="{item}">
                <td>
                    <Link :href="$route('customers.customers.show', {customer: item.customerId})">
                        {{ item.customerId }}
                    </Link>
                </td>
            </template>
            <template #contractId="{item}">
                <td>
                    <Link :href="$route('customers.customers.contracts.show', {contract: item.contractId, customer: item.customerId})">
                        {{ item.contractId }}
                    </Link>
                </td>
            </template>
            <template #invoiceId="{item}">
                <td>
                    <Link :href="$route('customers.customers.invoices.show', {customer: item.customerId, invoice: item.invoiceId})">
                        {{ item.invoiceId }}
                    </Link>
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="invoices.last_page > 1"
            :active-page="invoices.current_page"
            :pages="invoices.last_page"
            align="center"
            @update:activePage="changePage"
        />
    </DCard>
</template>

<script>

import _ from 'lodash'

export default {
    name: 'InvoicesIndex',
    props: {
        invoices: {
            type: Array,
            default: () => { return [] }
        },
        modules: {
            type: Array,
            default: () => { return [] }
        },
        status: {
            type: Array,
            default: () => { return [] }
        },
        filters: {
            type: Object,
            default: () => {
                return {
                    customerId: null,
                    invoiceId: null,
                    contractId: null
                }
            }
        }
    },
    data () {
        return {
            form: this.$inertia.form({
                items: []
            }),
            fields: [
                { key: 'customerId', label: this.__('tools.providerbox.table.customer_id') },
                { key: 'companyName', label: this.__('tools.providerbox.table.company_name') },
                { key: 'customerName', label: this.__('tools.providerbox.table.customer_name') },
                { key: 'contractId', label: this.__('tools.providerbox.table.contract_id') },
                { key: 'invoiceId', label: this.__('tools.providerbox.table.invoice_id') }
            ],
            dataFilters: _.cloneDeep(this.filters)
        }
    },
    computed: {
        moduleOptions () {
            const modules = _.cloneDeep(this.modules)

            for (const module in modules) {
                if (this.filters.modules.includes(modules[module].value)) {
                    modules[module].selected = true
                }
            }

            return modules
        }
    },
    methods: {
        changePage (page) {
            const queryParameters = Object.fromEntries(Object.entries(this.dataFilters).filter(([_, v]) => v))

            if (page !== 1) {
                queryParameters.page = page
            }

            this.$inertia.get(this.$route('tools.providerbox.invoices-index', {
                saveFilters: true
            }), queryParameters)
        },
        resetFilters () {
            this.dataFilters.customerId = null
            this.dataFilters.contractId = null
            this.dataFilters.invoiceId = null
            const queryParameters = Object.fromEntries(Object.entries(this.dataFilters).filter(([_, v]) => v))
            this.$inertia.get(this.$route('tools.providerbox.invoices-index', {
                saveFilters: true,
                defaultFilters: true
            }), queryParameters)
        }
    }
}
</script>

<style scoped>
</style>
